import React from "react";

const Reviews = () => {
  return (
    <div className="mt-9 flex flex-col gap-6 items-center relative">
      <div className="flex items-center gap-6">
        <Review />
        <Review dark />
        <Review />
        <Review dark />
      </div>
      <div className="flex items-center gap-6">
        <Review dark />
        <Review />
        <Review dark />
        <Review />
        <Review dark />
        <Review />
        <Review />
      </div>
    </div>
  );
};

export default Reviews;

const Review = ({ dark }: { dark?: boolean }) => {
  return (
    <div
      className={`${
        dark ? "bg-card-dark" : "bg-card-light"
      } p-5 rounded-2xl w-[300px] sm:w-[400px]`}
    >
      <p
        className={`${
          dark ? "text-white" : "text-sub-text "
        } text-sm font-medium tracking-wide leading-6 sm:leading-8`}
      >
        “To be honest, I was very skeptical at first when they told me that I
        will get a monthly payment with my savings but, with Loana, It feels
        like I have a new salary”
      </p>
      <div className="mt-4 sm:mt-10 flex items-center gap-2">
        <div className="size-10 bg-neutral-300 bg-[url('https://images.unsplash.com/photo-1521566652839-697aa473761a')] bg-center bg-cover rounded-full"></div>
        <div className="text-left">
          <p
            className={`${
              dark ? "text-white" : "text-loana-black"
            } text-sm font-semibold`}
          >
            Rita Awaya
          </p>
          <p className="text-sub-text text-xs">Marketing Lead</p>
        </div>
      </div>
    </div>
  );
};
